import * as T from './types';

export const initialState: T.State = {
  alert: null,
};

export default (state: T.State = initialState, action: T.Action | any): T.State => {
  switch (action.type) {
    case 'ALERT_DISMISS':
      return {
        ...state,
        alert: null,
      };
    case 'ALERT_SET':
      return {
        ...state,
        alert: action.alert,
      };
    default:
      return state;
  }
};
